import React, { Suspense } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { LoadingIndicator } from "../components/LoadingNavigator";

import LoginSessionPage from "../pages/LoginSessionPage";
import DetailPage from "../pages/DetailPage";
import { PrivateRoute } from "./PrivateRoute"; // ⬅️ import guard
import LoginPage from "../pages/LoginPage";

const RootComponent: React.FC = () => {
  return (
    <Router>
      <Suspense fallback={<LoadingIndicator />}>
        <Routes>
          <Route path="" element={<LoginPage />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <LoginSessionPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/detail/:socketId"
            element={
              <PrivateRoute>
                <DetailPage />
              </PrivateRoute>
            }
          />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default RootComponent;
